const config = {
  plugins: {
    "@tailwindcss/postcss": {},
  },
}

export default config
